import React from 'react';

import * as ResourceApi from 'api/resources';
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";
import {createButtonSectionFactory} from "hoc/CreateButtonSection";
import {isNoU, undeletedItems} from "utils/DBUtils";
import {isNewLayout} from 'utils/break-utils';

export default {
  name: "referralLinks",
  subSection: true,
  resource: true,
  hideIfResourceIsNoU: true,

  fields: [
    {
      type: 'radio',
      name: 'layout',
      required: true,
      props: {
        labelKey: 'editbreak.steps.referral.layout',
        options: [
          {
            textKey: 'editbreak.steps.referral.layout.single_column',
            value: 'ONE_COLUMN'
          },
          {
            textKey: 'editbreak.steps.referral.layout.two_column',
            value: 'TWO_COLUMN'
          },
          {
            textKey: 'editbreak.steps.referral.layout.three_column',
            value: 'THREE_COLUMN'
          }
        ]
      }
    },
    {
      type: 'contenteditable',
      name: 'headline',
      required: false,
      linkedField: (proxy) => ["title"],
      props: {
          labelKey: 'editbreak.steps.referral.headline',
          placeholderKey: 'editbreak.steps.referral.headline.placeholder',
      }
    },
    {
        type: 'contenteditable',
        name: 'introCopy',
        required: false,
        props: {
          labelKey: 'editbreak.steps.referral.intro_copy',
          maxLength: 500,
          placeholderKey: 'editbreak.steps.referral.intro_copy.placeholder',
          validationRules: [
              {
                  type: 'MarkupTextLimit',
                  params: {
                      limit: 500
                  }
              }
          ]

        }
    },

    {
      type: 'radio',
      name: 'headerType',
      required: true,
      props: {
        labelKey: 'Header Asset',
        options: [
            {
                value: "NONE",
                text: 'None'
            },
            {
                value: "IMAGE",
                text: 'Image'
            },
            {
                value: "VIDEO",
                text: 'Video'
            }
        ]
      }
    },

    {
        type: 'image',
        name: 'headerImageId',
        required: true,
        idFor: 'headerImage',
        showField: (proxy) => isNewLayout(proxy.currentResource) && proxy.currentResource.headerType === 'IMAGE',
        props: {
            labelKey: 'editbreak.steps.referral.header_image',
            imageType: 'referralHeader'
        }
    },

    {
      type: 'text',
      name: 'videoId',
      required: true,
      showField: (proxy) => isNewLayout(proxy.currentResource) && proxy.currentResource.headerType === 'VIDEO',
      props: {
          labelKey: 'Video Id',
      }
    },

    {
        type: 'contenteditable',
        name: 'topText',
        required: false,
        showField: (proxy) => (proxy.currentResource.layout === 'ONE_COLUMN'),
        props: {
          labelKey: 'editbreak.steps.referral.top_text',
          placeholderKey: 'editbreak.steps.referral.top_text.placeholder'
        }
    },
    {
        type: 'contenteditable',
        name: 'bottomText',
        required: false,
        props: {
          labelKey: 'editbreak.steps.referral.bottom_text',
          placeholderKey: 'editbreak.steps.referral.bottom_text.placeholder'
        }
    },
    {
        type: 'color',
        name: 'defaultButtonColor',
        required: false,
        linkedField: (formProxy) => ["missionColor5"],
        props: {
          labelKey: 'editbreak.steps.referral.default_button_color'
        }
    },
    {
      type: 'radio',
      name: 'voteType',
      required: true,
      props: {
        labelKey: 'Enable Voting?',
        options: [
          {
            textKey: 'No voting',
            value: 'NONE'
          },
          {
            text: 'Votes tallied per item',
            value: 'PER_ITEM'
          },
          {
            textKey: 'Votes tallied across all items',
            value: 'ALL_ITEMS'
          }
        ]
      }
    },    
    {
      name: 'referralLinks',
      subSection: true,
      resource: true,
      hideIfResourceIsNoU: true,
      collection: true,
      sectionWrapper: IndexedSubSectionWrapper,
      deletable: true,
        sortable: true,
        sortableName: "referralLinksOrder",
        toggleSortLabelKey: 'editbreak.steps.referral.link.reorder_toggle',


      canDelete: (formProxy) => {
        let step = formProxy.parentCurrentResource;
        if ( isNoU(step.referralLinks) || step.referralLinks.length === 1) { return false; }
        let visibleLinksCount = 0;  // need to check only undeleted links
        for (var i=0;i<step.referralLinks.length;i++) {
          if (!step.referralLinks[i].deleted) {
            visibleLinksCount++;
          }
        }

        if ( formProxy.parentCurrentResource.layout === 'TWO_COLUMN' ) {
          return visibleLinksCount > 2;
        } else if ( formProxy.parentCurrentResource.layout === 'THREE_COLUMN' ) {
          return visibleLinksCount > 3;
        }

        return visibleLinksCount > 1;
      },
      resourceType: ResourceApi.Types.ReferralLink,
      props: {
        // headerKey: 'editbreak.steps.referral.link.header',
        getCustomSectionHeader: (content, i) => {
            // console.log(`content`, content)
            if (content.buttonType === "MENU") {
                return content.menu ? `Menu: ${content.menu.text} [${i}]` : `Menu ${i}`
            }

            if (content.buttonType === "BUTTON") {
                return `Button: ${content.buttonText} [${i}]` 
            }

            return `Referral ${i}`
        }
      },
      footerContent: createButtonSectionFactory(ResourceApi.Types.ReferralLink),
      fields: [
        {
          name: 'url',
          type: 'text',
          required: true,
          props: {
            labelKey: 'editbreak.steps.referral.link.url'
          }
        },
        {
          type: 'yesnoradio',
          name: 'showButton',
          required: true,
          props: {
            labelKey: 'editbreak.steps.referral.link.show_button'
          }
        },
        {
          name: 'buttonType',
          type: 'radio',
          required: true,
          showField: (proxy) => (proxy.currentResource.showButton === true),
          props: {
            labelKey: 'editbreak.steps.referral.link.cta_type',
            options: [
              {
                value: 'BUTTON',
                textKey: 'editbreak.steps.referral.link.cta_type.button'
              },
              {
                value: 'TEXT',
                textKey: 'editbreak.steps.referral.link.cta_type.text'
              },
              {
                value: 'MENU',
                textKey: 'editbreak.steps.referral.link.cta_type.menu'
              }
            ]
          }
        },
        {
            type: 'color',
            name: 'buttonColor',
            required: false,
            linkedField: (proxy) => {
              var path = proxy.parentPath();
              path.push("buttonColor");
              let currentStepLevelColor = proxy.currentValueForField(path);
              if ( typeof(currentStepLevelColor) === 'undefined' ) {
                return ["missionColor5"]; // default to break button color
              }

              return path;
            },
            props: {
              labelKey: 'editbreak.steps.referral.link.button_color'
            }
        },
        {
          name: 'menu',
          subSection: true,
          resource: true,
          collection: false,
          sectionWrapper: IndexedSubSectionWrapper,
          showSection: (proxy) => (proxy.parentCurrentResource.buttonType === 'MENU'),
          deletable: false,

          props: {
            headerKey: 'editbreak.steps.referral.menu.header',
              getCustomSectionHeader: (content) => {
                "Menu";
              },
          },

          resourceType: ResourceApi.Types.MenuContent,

          fields: [
              //
              // Menu Content
              //
              {
                  name: 'text',
                  type: 'contenteditable',
                  required: true,
                  props: {
                      labelKey: 'editbreak.steps.article.menucontent.text',
                  }
              },
              {
                conditionalSection: true,
                name: "hasCustomColors",
                required: true,
                props: {
                    labelKey: 'editbreak.steps.referral.menu.hasCustomColors',
                    defaultValue: false
                },

                fields: [
                  {
                    type: 'color',
                    name: 'backgroundColor',
                    required: false,
                    // setting a default actually makes the UI worse. User assumes color is in place, but it isn't saved yet, so it isn't.
                    // linkedField: (proxy) => {
                    //   var path = proxy.parentPath();
                    //   path.push("backgroundColor");
                    //   let currentValue = proxy.currentValueForField(path);
                    //   if ( typeof(currentValue) === 'undefined' ) {
                    //     return ["missionColor5"]; // missionColor5 = buttonColor
                    //   }

                    //   return path;
                    // },
                    props: {
                      labelKey: 'editbreak.steps.referral.menu.backgroundColor'
                    }
                  },
                  {
                    type: 'color',
                    name: 'textColor',
                    required: false,
                    // setting a default actually makes the UI worse. User assumes color is in place, but it isn't saved yet, so it isn't.
                    // linkedField: (proxy) => {
                    //   var path = proxy.parentPath();
                    //   path.push("textColor");
                    //   let currentValue = proxy.currentValueForField(path);
                    //   if ( typeof(currentValue) === 'undefined' ) {
                    //     return ["missionColor6"]; // missionColor6 == brandThemeText
                    //   }

                    //   return path;
                    // },
                    props: {
                      labelKey: 'editbreak.steps.referral.menu.textColor'
                    }
                  },

                  {
                    type: 'color',
                    name: 'hoverBackgroundColor',
                    required: false,
                    // setting a default actually makes the UI worse. User assumes color is in place, but it isn't saved yet, so it isn't.
                    // linkedField: (proxy) => {
                    //   var path = proxy.parentPath();
                    //   path.push("hoverBackgroundColor");
                    //   let currentValue = proxy.currentValueForField(path);
                    //   if ( typeof(currentValue) === 'undefined' ) {
                    //     return ["missionColor5"]; // missionColor5 = buttonColor
                    //   }

                    //   return path;
                    // },
                    props: {
                      labelKey: 'editbreak.steps.referral.menu.hoverBackgroundColor'
                    }
                  },
                  {
                    type: 'color',
                    name: 'hoverTextColor',
                    required: false,
                    // setting a default actually makes the UI worse. User assumes color is in place, but it isn't saved yet, so it isn't.
                    // linkedField: (proxy) => {
                    //   var path = proxy.parentPath();
                    //   path.push("hoverTextColor");
                    //   let currentValue = proxy.currentValueForField(path);
                    //   if ( typeof(currentValue) === 'undefined' ) {
                    //     return ["missionColor6"]; // missionColor6 == brandThemeText
                    //   }

                    //   return path;
                    // },
                    props: {
                      labelKey: 'editbreak.steps.referral.menu.hoverTextColor'
                    }
                  },
                    ]
            },

              {
                  name: 'items',
                  subSection: true,
                  resource: true,
                  collection: true,
                  sectionWrapper: IndexedSubSectionWrapper,
                  deletable: true,
                  canDelete: (formProxy) => {
                      const parent = formProxy.parentCurrentResource;
                      return parent.items && undeletedItems(parent.items).length > 1;
                  },
                  canCreate: (formProxy) => {
                      const parent = formProxy.parentCurrentResource;
                      return parent.items && undeletedItems(parent.items).length < 15;
                  },

                  props: {
                      getCustomSectionHeader: (content, sectionIndex) => {
                          if ( content.label && content.label.trim() !== "") {
                              return 'Menu Item ' + (sectionIndex+1) + ': ' + content.label;
                          }

                          return 'Menu Item';
                      },
                  },
                  footerContent: createButtonSectionFactory(
                      ResourceApi.Types.MenuContentItem
                  ),

                  sortable: true,
                  sortableName: "menuItemsOrder",
                  toggleSortLabelKey: 'editbreak.steps.article.content.reorder_toggle',
                  resourceType: ResourceApi.Types.MenuContentItem,

                  fields: [
                      {
                          name: 'label',
                          type: 'text',
                          required: true,
                          props: {
                              labelKey: 'editbreak.steps.article.menucontent.item.label'
                          }
                      },
                      {
                          name: 'link',
                          type: 'text',
                          required: true,
                          props: {
                              labelKey: 'editbreak.steps.article.menucontent.item.link',
                              starterValue: "https://",
                              validationRules: [
                                  {
                                      type: 'HyperLinkFormat'
                                  }
                              ]
                          }
                      },
                      {
                          name: 'imageId',
                          type: 'image',
                          idFor: 'image',
                          props: {
                              labelKey: 'editbreak.steps.article.menucontent.item.image',
                              imageType: 'menuContentIcon',
                          }
                      },
                  ]
              },

              // End Menu Content

            ]
        },
        {
          name: 'buttonText',
          type: 'text',
          required: true,
          showField: (proxy) => (proxy.currentResource.showButton === true && proxy.currentResource.buttonType === 'BUTTON'),
          props: {
            labelKey: 'editbreak.steps.referral.link.cta.button_text',
            maxLength: 20,
            validationRules: [
                {
                    type: 'MarkupTextLimit',
                    params: {
                        limit: 20
                    }
                }
            ]
          }
        },
        {
          name: 'buttonText',
          type: 'text',
          required: true,
          showField: (proxy) => (proxy.currentResource.showButton === true && proxy.currentResource.buttonType === 'TEXT'),
          props: {
            labelKey: 'editbreak.steps.referral.link.cta.text'
          }
        },
        // {
        //   name: 'headerImageId',
        //   idFor: 'headerImage',
        //   type: 'image',
        //   showField: (proxy) => (proxy.parentCurrentResource.layout === 'ONE_COLUMN'),
        //   required: true,
        //   props: {
        //     labelKey: 'editbreak.steps.referral.link.header_image',
        //     imageType: 'referralHeader'
        //   }
        // },
        {
          name: 'headerImageId',
          idFor: 'headerImage',
          type: 'image',
          showField: (proxy) => ((proxy.parentCurrentResource.layout === 'TWO_COLUMN') && !isNewLayout(proxy.parentCurrentResource)),
          required: true,
          props: {
            labelKey: 'editbreak.steps.referral.link.header_image',
            imageType: 'referralTwoColumn'
          }
        },
        {
          name: 'headerImageId',
          idFor: 'headerImage',
          type: 'image',
          showField: (proxy) => ((proxy.parentCurrentResource.layout === 'THREE_COLUMN') && !isNewLayout(proxy.parentCurrentResource)),
          required: true,
          props: {
            labelKey: 'editbreak.steps.referral.link.header_image',
            imageType: 'referralThreeColumn'
          }
        },
        {
            name: 'headerImageId',
            idFor: 'headerImage',
            type: 'image',
            showField: (proxy) => {
                // console.log("PROXY")
                // console.log(proxy.parentCurrentResource.layout )
                // console.log(isNewLayout(proxy.currentResource))
                return ((proxy.parentCurrentResource.layout === 'TWO_COLUMN') && isNewLayout(proxy.parentCurrentResource))
            },
            required: true,
            props: {
              labelKey: 'editbreak.steps.referral.link.header_image.3x2',
              imageType: 'referral3x2'
            }
          },
          {
            name: 'headerImageId',
            idFor: 'headerImage',
            type: 'image',
            showField: (proxy) => ((proxy.parentCurrentResource.layout === 'THREE_COLUMN') && isNewLayout(proxy.parentCurrentResource)),
            required: true,
            props: {
              labelKey: 'editbreak.steps.referral.link.header_image.3x2',
              imageType: 'referral3x2'
            }
          },

        {
          name: 'topText',
          type: 'contenteditable',
          required: false,
          props: {
            labelKey: 'editbreak.steps.referral.link.cta.top_text'
          }
        },
        {
          name: 'bottomText',
          type: 'contenteditable',
          required: false,
          props: {
            labelKey: 'editbreak.steps.referral.link.cta.bottom_text'
          }
        },
        // {
        //   type: 'yesnoradio',
        //   name: 'hasGoal',
        //   required: false,
        //   props: {
        //     labelKey: 'editbreak.steps.referral.link.has_goal',
            
        //   }
        // },
        {
          type: 'number',
          name: 'goal',
          required: false,
          showField: (proxy) => {            
            // return proxy.currentResource.hasGoal === true
            return (proxy.parentCurrentResource.voteType === 'PER_ITEM')
          },
          props: {
            labelKey: 'Voting Goal (Individual Item)',
            min: 0,
          }
        },

        {
          type: 'color',
          name: 'barColor',
          required: false,
          showField: (proxy) => {
            // return proxy.currentResource.hasGoal === true
            return ((proxy.parentCurrentResource.voteType === 'PER_ITEM') || (proxy.parentCurrentResource.voteType === 'ALL_ITEMS'))
          },
          props: {
            labelKey: 'Vote Progress Bar Color'
          }
        },
        {
          type: 'color',
          name: 'barHighlightColor',
          required: false,
          showField: (proxy) => {
            // return proxy.currentResource.hasGoal === true
            return ((proxy.parentCurrentResource.voteType === 'PER_ITEM') || (proxy.parentCurrentResource.voteType === 'ALL_ITEMS'))
          },
          props: {
            labelKey: 'Vote Progress Bar highlight color'
          }
        },
        {
          type: 'color',
          name: 'barCompleteColor',
          required: false,
          showField: (proxy) => {
            // return proxy.currentResource.hasGoal === true
            return ((proxy.parentCurrentResource.voteType === 'PER_ITEM') || (proxy.parentCurrentResource.voteType === 'ALL_ITEMS'))
          },
          props: {
            labelKey: 'Vote Progress Bar Complete Color'
          }
        },
        {
          name: 'eventName',
          type: 'radio',
          required: false,
          showField: (proxy) => !isNewLayout(proxy.parentCurrentResource),
          supportedPlatforms: [
              'MASTER'
          ],
          props: {
            labelKey: 'editbreak.steps.referral.link.tracking_type',
            options: [
              {
                value: 'Referral Clicks',
                textKey: 'editbreak.steps.referral.link.tracking_type.referral'
              },
              {
                value: 'Coupon Downloads',
                textKey: 'editbreak.steps.referral.link.tracking_type.coupon'
              }
            ]
          }
        },
        {
            conditionalSection: true,
            name: "usesCouponsDotCom",
            required: false,
            showField: (proxy) => !isNewLayout(proxy.parentCurrentResource),
  
            props: {
                labelKey: 'editbreak.steps.referral.link.uses_coupons_dot_com'
            },

            fields: [
              {
                name: 'cdcShortCipherCode',
                type: 'text',
                required: true,
                props: {
                  labelKey: 'editbreak.steps.referral.link.cdc_short_cipher'
                }
              },
              {
                name: 'cdcLongCipherCode',
                type: 'text',
                required: true,
                props: {
                  labelKey: 'editbreak.steps.referral.link.cdc_long_cipher'
                }
              }
            ]
        },
          {
              type: 'dynamicContentRules',
              name: 'dynamics',
              required: true,
              showField: proxy => Boolean(proxy.currentBaseResource.steps.find(step => step.type === 'PERSONALITY_QUIZ')),
              props: {
                  labelKey: 'editbreak.steps.listicle.item.dynamics'
              }
          },
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/referral.js